module.exports = __webpack_public_path__ + "Neeko.512c07ef.json";